import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BoletoService } from '../services/boleto/boleto.service';
import { AppComponent } from '../app.component';
import { FaviconService } from '../services/favicon/favicon.service';
import { MatDialog } from '@angular/material/dialog';
import { showError } from 'src/utils/showErrorMessage';

@Component({
    selector: 'spe-imprimr-boleto',
    templateUrl: './imprimir-boleto.component.html',
    standalone: false
})
export class ImprimirBoletoPublico implements OnInit {
  public pdfUrl!: string;
  public screenWidth!: number;
  public screenHeight!: number;
  public showIframe = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private boletoService: BoletoService,
    private appComponent: AppComponent,
    private faviconService: FaviconService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.appComponent.hideHeader = true;
    this.getScreenSize();
    this.getParams();
    this.faviconService.changeFavicon('assets/favicon/64_icon_earth.png');
    this.faviconService.changeTitle('Imprimir boleto');
  }

  getParams() {
    this.activatedRoute.queryParams.subscribe((params) => {
      const isCenarioPedidoNovo = params.idPedido != undefined;
      const isCenarioPedidoAntigo = params.ID_PEDIDO_PED != undefined;
      const isCenarioCrecebAntigo = params.ID_CRECEB_CRE != undefined;
      const idChave = isCenarioPedidoNovo
        ? params.idPedido
        : isCenarioPedidoAntigo
        ? params.ID_PEDIDO_PED
        : params.ID_CRECEB_CRE;
      const tipoChave = isCenarioCrecebAntigo ? 3 : 1;
      const sistemaParametro = params.sistema ?? params.APP;
      const sistema = this.getSistema(sistemaParametro);
      this.getBoleto(idChave, sistema, tipoChave);
    });
  }

  getSistema(sistema: string) {
    let sistemaRetorno = '1';
    switch (sistema) {
      case 'SIG':
        sistemaRetorno = '2';
        break;
      case 'PME':
        sistemaRetorno = '3';
        break;
      case 'JOB-POS-PAGO':
        sistemaRetorno = '6';
        break;
    }
    return sistemaRetorno;
  }

  getBoleto(idChave: number, sistema: string, tipoChave: number) {
    this.boletoService.gerarBoleto(idChave, sistema, tipoChave).subscribe({
      next: (data) => {
        const url = window.URL.createObjectURL(data);
        this.pdfUrl = url;
        this.showIframe = true;
      },
      error: async (e) => {
        let blob: Blob = e.error;
        let jsonError = JSON.parse(await blob.text());
        showError(this.dialog, jsonError.mensagem);
      }
    });
  }

  @HostListener('window:resize')
  onResize() {
    this.getScreenSize();
  }

  getScreenSize() {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }
}
